import React from 'react';
import { Grid, makeStyles } from "@material-ui/core";
import CardArquivo from '../../../shared/components/CardArquivo';

const ListagemArquivos = ({ arquivos, handleExcluirArquivo, handleBaixarArquivo }) => {
    const classes = useStyles();

    return (
        arquivos?.length > 0 &&
        <Grid container spacing={3} className={"mb-2"}>
            {arquivos.map(arquivo =>
                <Grid item xs={4} className={classes.cardArquivo} key={arquivo.idTemp}>
                    <CardArquivo
                        arquivo={arquivo}
                        handleBaixarArquivo={handleBaixarArquivo}
                        handleExcluirArquivo={handleExcluirArquivo}
                    />
                </Grid>
            )}
        </Grid>
    );
}

const useStyles = makeStyles((theme) => ({
    cardArquivo: {
        marginTop: -theme.spacing(1),
        marginBottom: -theme.spacing(1),
    }
}));

export default ListagemArquivos;